import Confetti from 'canvas-confetti'
import "./modules/CookieConsent";

window.addEventListener('start-confetti', () => {
    Confetti();
})
